const CUSTOMER_DEFAULT_HOME_PATHS = {
  CUSTOMER_MANAGER: '/customer/status/tanks',
  CUSTOMER_USER: '/customer/status/tanks',
};

export const getDefaultHomePath = (role) => CUSTOMER_DEFAULT_HOME_PATHS[role] || '/dashboard/tanks';

export default getDefaultHomePath;
